export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTHORIZE_TOKEN = "AUTHORIZE_TOKEN";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_USERS = "GET_USERS";
export const GET_GIFTED_USERS = "GET_GIFTED_USERS";
export const GET_MENTORS = "GET_MENTORS";
export const GET_STREAM = "GET_STREAM";
export const STREAM_NOT_LIVE = "STREAM_NOT_LIVE";
export const GET_LIVE_STREAMS = "GET_LIVE_STREAMS";
export const GET_TIMED_OUT_USERS = "GET_TIMED_OUT_USERS";
export const GET_BANNED_USERS = "GET_BANNED_USERS";
export const TIMEOUT_USER = "TIMEOUT_USER";
export const UNTIMEOUT_USER = "UNTIMEOUT_USER";
export const BAN_USER = "BAN_USER";
export const UNBAN_USER = "UNBAN_USER";
export const BAN_ERROR = "BAN_ERROR";
export const STREAM_ERROR = "STREAM_ERROR";
export const GET_MODERATORS = "GET_MODERATORS";
export const MAKE_MODERATOR = "MAKE_MODERATOR";
export const UPDATE_MODERATOR = "UPDATE_MODERATOR";
export const REMOVE_MODERATOR = "REMOVE_MODERATOR";
export const MODERATOR_ERROR = "MODERATOR_ERROR";
export const GET_MESSAGES = "GET_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const MESSAGE_ERROR = "MESSAGE_ERROR";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const DELETE_CHAT_MESSAGE = "DELETE_CHAT_MESSAGE";
export const SEND_MOD_MESSAGE = "SEND_MOD_MESSAGE";
export const DELETE_MODCHAT_MESSAGE = "DELETE_MODCHAT_MESSAGE";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES";
export const CLEAR_MSG = "CLEAR_MSG";
export const CLEAR_USERS = "CLEAR_USERS";
export const CLEAR_DISCUSSION_USERS = "CLEAR_DISCUSSION_USERS";
export const GET_PURCHASES = "GET_PURCHASES";
export const PURCHASE_ERROR = "PURCHASE_ERROR";
export const GET_COURSES = "GET_COURSES";
export const GET_COURSE = "GET_COURSE";
export const GET_COURSE_VIDEO = "GET_COURSE_VIDEO";
export const CREATE_COURSE = "CREATE_COURSE";
export const ADD_COURSE_COMMENT = "ADD_COURSE_COMMENT";
export const DELETE_COURSE_COMMENT = "DELETE_COURSE_COMMENT";
export const COURSE_FAIL = "COURSE_FAIL";
export const GET_CONTENT = "GET_CONTENT";
export const CLEAR_CONTENT = "CLEAR_CONTENT";
export const CONTENT_ERROR = "CONTENT_ERROR";
export const GET_DISCUSSION = "GET_DISCUSSION";
export const GET_DISCUSSION_USERS = "GET_DISCUSSION_USERS";
export const CREATE_DISCUSSION = "CREATE_DISCUSSION";
export const END_DISCUSSION = "END_DISCUSSION";
export const DISCUSSION_ERROR = "DISCUSSION_ERROR";
export const GET_SUBSCRIPTIONS = "GET_SUBSCRIPTIONS";
export const GET_ACTIVE_SUBSCRIPTIONS = "GET_ACTIVE_SUBSCRIPTIONS";
export const GET_SUBSCRIBERS = "GET_SUBSCRIBERS";
export const GET_PAYMENT_CONFIRMATION = "GET_PAYMENT_CONFIRMATION";
export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const SUBSCRIPTION_FAIL = "SUBSCRIPTION_FAIL";
export const SUBSCRIBE_FAIL = "SUBSCRIBE_FAIL";
export const CLEAR_SUBSCRIBERS = "CLEAR_SUBSCRIBERS";
export const CLEAR_GIFTED_SUBSCRIBERS = "CLEAR_SUBSCRIBERS";
export const CLEAR_SUBSCRIPTIONS = "CLEAR_SUBSCRIPTIONS";
export const GET_PROFILE = "GET_PROFILE";
export const JOIN_PROFILE_COMMUNITY = "JOIN_PROFILE_COMMUNITY";
export const UNJOIN_PROFILE_COMMUNITY = "UNJOIN_PROFILE_COMMUNITY";
export const SET_PROFILE_STATUS = "SET_PROFILE_STATUS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS";
export const PROFILE_ERROR = "PROFILE_ERROR";
export const IMAGE_UPLOADED = "IMAGE_UPLOADED";
export const GET_FRIENDS = "GET_FRIENDS";
export const GET_USER_FRIENDS = "GET_FRIENDS";
export const CLEAR_FRIENDS = "CLEAR_FRIENDS";
export const FOLLOW_USER = "FOLLOW_USER";
export const SEND_BUSINESS_CASUAL_REQUEST = "SEND_BUSINESS_CASUAL_REQUEST";
export const SEND_USER_REQUEST = "SEND_USER_REQUEST";
export const ADD_FRIEND = "ADD_FRIEND";
export const REMOVE_FRIEND = "REMOVE_FRIEND";
export const ACCEPT_APPROVAL = "ACCEPT_APPROVAL";
export const REMOVE_APPROVAL_REQUEST = "REMOVE_APPROVAL_REQUEST";
export const FRIEND_ERROR = "FRIEND_ERROR";
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";
export const SEND_CASUAL_NOTIFICATION = "SEND_CASUAL_NOTIFICATION";
export const ACCEPTED_CASUAL_NOTIFICATION = "ACCEPTED_CASUAL_NOTIFICATION";
export const ACCEPTED_APPROVAL_NOTIFICATION = "ACCEPTED_APPROVAL_NOTIFICATION";
export const FOLLOWER_NOTIFICATION = "FOLLOWER_NOTIFICATION";
export const APPROVAL_NOTIFICATION = "APPROVAL_NOTIFICATION";
export const NOTIFICATION_ERROR = "NOTIFICATION_ERROR";
export const GET_POSTS = "GET_POSTS";
export const GET_INFINITE_SCROLL_POSTS = "GET_INFINITE_SCROLL_POSTS";
export const GET_POSTS_BY_REACTION = "GET_POSTS_BY_REACTION";
export const GET_POST_COMMENTS = "GET_POST_COMMENTS";
export const GET_POST_COMMENT_REPLIES = "GET_POST_COMMENT_REPLIES";
export const CLEAR_POSTS = "CLEAR_POSTS";
export const GET_GIFS = "GET_GIFS";
export const GET_GIFS_SEARCH = "GET_GIFS_SEARCH";
export const GIF_ERROR = "GIF_ERROR";
export const GET_INDUSTRY_EPISODES = "GET_INDUSTRY_EPISODES";
export const GET_INDUSTRY_EPISODE = "GET_INDUSTRY_EPISODE";
export const INDUSTRY_ERROR = "INDUSTRY_ERROR";
export const GET_COMPANY_EPISODES = "GET_COMPANY_EPISODES";
export const GET_COMPANY_EPISODE = "GET_COMPANY_EPISODE";
export const COMPANY_ERROR = "COMPANY_ERROR";
export const GET_ARTICLES = "GET_ARTICLES";
export const CREATE_ARTICLE = "CREATE_ARTICLE";
export const GET_IME_ARTICLES = "GET_IME_ARTICLES";
export const CLEAR_ARTICLE = "CLEAR_ARTICLE";
export const GET_SETTINGS = "GET_SETTINGS";
export const CREATE_SETTINGS = "CREATE_SETTINGS";
export const UPDATE_SETTING = "UPDATE_SETTING";
export const SETTING_ERROR = "SETTING_ERROR";
export const GET_TOURS = "GET_TOURS";
export const GET_JOB_POSTS = "GET_JOB_POSTS";
export const GET_APPLIED_JOBS = "GET_APPLIED_JOBS";
export const GET_ARTICLE = "GET_ARTICLE";
export const GET_RECENT_ARTICLE = "GET_RECENT_ARTICLE";
export const GET_ARTICLE_COMMENTS = "GET_ARTICLE_COMMENTS";
export const GET_IME_ARTICLE = "GET_IME_ARTICLE";
export const GET_TOUR = "GET_TOUR";
export const GET_JOB_POST = "GET_JOB_POST";
export const APPLY = "APPLY";
export const ACCEPT_APPLICATION = "ACCEPT_APPLICATION";
export const DECLINE_APPLICATION = "DECLINE_APPLICATION";
export const REMOVE_APPLICANT = "REMOVE_APPLICANT";
export const POST_ERROR = "POST_ERROR";
export const ARTICLE_ERROR = "ARTICLE_ERROR";
export const IME_ARTICLE_ERROR = "IME_ARTICLE_ERROR";
export const CLEAR_TOURS = "CLEAR_TOURS";
export const CLEAR_APPLICANT = "CLEAR_APPLICANT";
export const CLEAR_JOBS = "CLEAR_JOBS";
export const TOUR_ERROR = "TOUR_ERROR";
export const JOB_ERROR = "JOB_ERROR";
export const UPDATE_REACTION = "UPDATE_REACTION";
export const UPDATE_ARTICLE_LIKES = "UPDATE_ARTICLE_LIKES";
export const UPDATE_IME_ARTICLE_LIKES = "UPDATE_IME_ARTICLE_LIKES";
export const UPDATE_TOUR_LIKES = "UPDATE_TOUR_LIKES";
export const DELETE_POST = "DELETE_POST";
export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const DELETE_MESSAGES = "DELETE_MESSAGES";
export const DELETE_CONVERSATION = "DELETE_CONVERSATION";
export const DELETE_ARTICLE = "DELETE_ARTICLE";
export const DELETE_IME_ARTICLE = "DELETE_IME_ARTICLE";
export const DELETE_TOUR = "DELETE_TOUR";
export const DELETE_JOB_POST = "DELETE_JOB_POST";
export const DELETE_JOB_APPLICATION = "DELETE_JOB_APPLICATION";
export const ADD_POST = "ADD_POST";
export const PIN_POST = "PIN_POST";
export const UNPIN_POST = "UNPIN_POST";
export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_POST_REPLY = "ADD_POST_REPLY";
export const ADD_IME_ARTICLE = "ADD_IME_ARTICLE";
export const ADD_TOUR = "ADD_TOUR";
export const ADD_JOB_POST = "ADD_JOB_POST";
export const ADD_ARTICLE_COMMENT = "ADD_ARTICLE_COMMENT";
export const ADD_ARTICLE_REPLY = "ADD_ARTICLE_REPLY";
export const ADD_IME_ARTICLE_COMMENT = "ADD_IME_ARTICLE_COMMENT";
export const ADD_IME_ARTICLE_REPLY = "ADD_IME_ARTICLE_REPLY";
export const REMOVE_COMMENT = "REMOVE_COMMENT";
export const REMOVE_REPLY = "REMOVE_REPLY";
export const REMOVE_ARTICLE_COMMENT = "REMOVE_ARTICLE_COMMENT";
export const REMOVE_IME_ARTICLE_COMMENT = "REMOVE_IME_ARTICLE_COMMENT";
export const GET_REPORTED_USERS = "GET_REPORTED_USERS";
export const DELETE_REPORT = "DELETE_REPORT";
export const REPORT_USER = "REPORT_USER";
export const REPORT_USER_ERROR = "REPORT_USER_ERROR";
export const BLOCK_USER = "BLOCK_USER";
export const BLOCK_USER_ERROR = "BLOCK_USER_ERROR";
export const GET_BLOCKED_USERS = "GET_BLOCKED_USERS";
export const GET_BLOCKED_USERS_ERROR = "GET_BLOCKED_USERS_ERROR";
export const UNBLOCK_USER = "UNBLOCK_USER";
export const UNBLOCK_USER_ERROR = "UNBLOCK_USER_ERROR";
export const CLEAR_BLOCKED_USERS = "CLEAR_BLOCKED_USERS";
export const GET_SUPPORTERS = "GET_SUPPORTERS";
export const ADD_SUPPORTER = "ADD_SUPPORTER";
export const DELETE_SUPPORTER = "DELETE_SUPPORTER";
export const SUPPORTER_ERROR = "SUPPORTER_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const TEMPORARY_PASSWORD_CONFIRMED = "TEMPORARY_PASSWORD_CONFIRMED";
export const RESET_PASSWORD_FAIL = "RESET_PASSWORD_FAIL";
export const CLEAR_EMAIL = "CLEAR_EMAIL";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_ACCOUNT = "DELETE_USER_ACCOUNT";
export const DELETE_USER_ACCOUNT_ERROR = "DELETE_USER_ACCOUNT_ERROR";
export const DELETE_USER_ERROR = "DELETE_USER_ERROR";
